module.exports = __webpack_public_path__ + "images/category_lp/bike/point3_8dbd3be4a34c67060b8635c5051d61c1.png";